export default "__VITE_ASSET__BXsqvIAU__"